define(['jquery','./jquery.formatCurrency'], function($, jqFormatCurrency) {
	var handleIndentInit = function($element) {
		handleIndent($element);
		$element.off('blur.indent change.indent sliderChanged.indent').on('blur.indent change.indent sliderChanged.indent', $element, function(){
			handleIndent($element);
		}).off('keyup.indent').on('keyup.indent', $element, function(n) {
			n = window.event || n;
			var t = n.charCode || n.keyCode;

			if (!!n) switch (t) {
				case 27:
					this.value = '';
					break;
				case 16:
					break;
				case 17:
					break;
				case 18:
					break;
				case 20:
					break;
				case 33:
					break;
				case 34:
					break;
				case 35:
					break;
				case 36:
					break;
				case 144:
					break;
				case 37:
					break;
				case 38:
					break;
				case 39:
					break;
				case 40:
					break;
				case 78:
					break;
				case 110:
					break;
				case 190:
					break;
				default:
					handleIndent($element);
			}
		})

	};

	var handleIndent = function($element) {
		$element.formatCurrency({
			colorize: false,
			symbol: '',
			positiveFormat: '%n',
			negativeFormat: '-%n %s',
			roundToDecimalPlace: -1,
			eventOnDecimalsEntered: false,
			decimalSymbol: ',',
			digitGroupSymbol: ' ',
			groupDigits: true
		})
	};


	// inicializace moznosti vkladat jen urcite znaky
	$('.form-control[data-indent]').each(function(){
		handleIndentInit($(this));
	});
	$(document).ajaxComplete(function(){
		$('.form-control[data-indent]').each(function(){
			handleIndentInit($(this));
		});
	});
});



// WEBPACK FOOTER //
// ./config/fe/web-default/src/js/web/jquery.formControlIndent.js